import g1 from "../images/projects/g1.jpg";
import g2 from "../images/projects/g2.jpg";
import g3 from "../images/projects/g3.jpg";
import g4 from "../images/projects/g4.jpg";
import g5 from "../images/projects/g5.jpg";
import g6 from "../images/projects/g6.jpg";
import bg1 from "../desktop/graphic/BG-Graphics-1.svg";
import bg2 from "../desktop/graphic/BG-Graphics-2.svg";
import bg3 from "../desktop/graphic/BG-Graphics-3.svg";
import bg4 from "../desktop/graphic/BG-Graphics-4.svg";

const bgGraphic = { bg1, bg2, bg3, bg4 };
export default [g1, g2, g3, g4, g5, g6];

const project = [
  {
    img: g1,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
  },
  {
    img: g2,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
  },
  {
    img: g3,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
  },
  {
    img: g4,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: [
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
    ],
  },
  {
    img: g5,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: [
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
    ],
  },
  {
    img: g6,
    title: "Project title",
    date: "5th Feb, 2022",
    client: "Delta State",
    projectSummary: `
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor inciddunt ut labore et dolore magna aligwa. Ut enim ad minim beniam, quis nostrud eercitation ullamco laboris nisi ut aliquip ex ea commodo conssecua.`,
  },
];

export { project, bgGraphic };
